module.exports = __webpack_public_path__ + "img/VPSvsVDS.670b40b.webp";